import { ReactNode } from "react";

interface EmptyStateProps {
  icon: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 space-y-4 text-center">
      <div className="bg-slate-100 p-4 rounded-full">
        {icon}
      </div>
      <h3 className="font-medium text-lg text-slate-800">{title}</h3>
      {description && (
        <p className="text-slate-500 max-w-md">
          {description}
        </p>
      )}
      {action && (
        <div className="pt-2">
          {action}
        </div>
      )}
    </div>
  );
}